'use strict'

const { EventEmitter } = require('events')

// ## Usage
// let vc = new VariantModel(options)
//   // matrix[][]
//   .on('change', (matrix) => {
//     // {
//     //   selected: `Boolean`,
//     //   available: `Boolean`
//     // }
//     updateView(matrix)
//   })

// updateView(matrix)

// vc.select(1, 0)
// vc.val() // null or variant.id

let UNDEFINED

module.exports = class VariantModel extends EventEmitter {
  constructor ({
    availables,
    dimensions,
    variant
  }) {
    super()
    this.availables = availables
    this.dimensions = dimensions
    this.variant = []
    this.cache = {}

    this._memoize('_availableVariants')
    this._initSelect(variant)
    setTimeout(() => {
      this._emitChange()
    })
  }

  _initSelect (variant) {
    let choosen

    this.availables.some((a) => {
      if (a.id === variant) {
        choosen = a.group
        return true
      }
    })
    
    if (!this.availables.length) return

    if (!choosen) {
      choosen = this.availables[0].group
    }

    if (!choosen) {
      this.availables[0].group = choosen = []
    }
    choosen.some((value, index) => {
      return !this._select(value, index)
    })
  }

  _matrix () {
    return this.dimensions.map((dimension, index) => {
      return dimension.choices.map((choice, i) => {
        return {
          selected: this._selected(i, index),
          available: this._isAvailable(i, index)
        }
      })
    })
  }

  _emitChange () {
    let done = this.variant.length === this.dimensions.length
      && this.variant.every((value) => {
        return value !== UNDEFINED
      })
    let matrix = this._matrix()
    if (this.dimensions.length === 0) {
      done = true
    }
    this.emit('change', {
      matrix,
      // true if all dimensions are set
      done
    })
  }

  val () {
    let selected
    this.availables.some((a) => {
      let match = equal(a.group, this.variant)
      if (match) {
        selected = a
        return true
      }

      return match
    })

    return selected && selected.id || null
  }

  select (value, index) {
    return this._select(value, index, true)
  }

  _selected (value, index) {
    return this.variant[index] === value
  }

  // try to select a dimension
  _select (value, index, emit) {
    if (this._selected(value, index)) {
      return
    }

    let available = this._isAvailable(value, index)
    // not set
    if (!available) {
      return false
    }

    this.variant[index] = value

    let length = this.dimensions.length
    // check all latter dimensions
    while (++ index < length) {
      this._check(index)
    }

    if (emit) {
      this._emitChange()
    }

    return true
  }

  // check the current value of a dimension,
  // if validation fails, unset the value
  _check (index) {
    let value = this.variant[index]
    if (value !== UNDEFINED && !this._isAvailable(value, index)) {
      this.variant[index] = UNDEFINED
    }
  }

  _availableVariants (choosen) {
    let length = choosen.length
    if (length === 0) {
      return this.availables
    }

    if (length >= this.dimensions.length) {
      return []
    }

    length --
    let sub = choosen.slice(0, length)
    let last = choosen[length]

    return this._availableVariants(sub).filter((a) => {
      return last === UNDEFINED || a.group[length] === last
    })
  }

  _memoize (name) {
    let method = this[name]
    this[name] = (array) => {
      let atom = join(array)
      if (atom in this.cache) {
        return this.cache[atom]
      }

      return this.cache[atom] = method.call(this, array)
    }
  }

  _isAvailable (value, index) {
    let choosen = this.variant.slice(0, index)
    let availables = this._availableVariants(choosen)

    if (!availables || !availables.length) {
      return false
    }

    return availables.some((a) => {
      return a.group[index] === value
    })
  }
}


function join (array) {
  return array.join('_')
}


function equal (a, b) {
  return join(a) === join(b)
}





// WEBPACK FOOTER //
// ./static/plugins/select-variant/lib/variant-model.js